// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2 — виды вкладки «Сторінки»): виды панели страниц — Pages / Pages and widgets / Previews —
// ОДИН механизм для PagesPanel и вкладки Pages формы меню рабочей области (WorkspaceMenuForm): перенесено из PagesPanel.vue как есть (mixin Vue options API).
// Состояние: viewId (память вида — этот браузер, пользователь и база: localStorage pagesPanelView:<пользователь>:<база>, общая у обоих мест), ratio (пропорция карточки);
// computed views / viewCur, методы viewSet, pagesViews_open (при открытии: вид из памяти, пропорция, кэш схем, миниатюры), schemaOf / picsOf / previewsLoad / tipPreviewOf (карточка Previews
// и превью в Alt-подсказке). Выключатель fe.ux.pagesPanelViews = false — переключателя нет, вид «Pages and widgets» (как раньше). onlyPage (панель одной страницы) — вид Pages
import { t } from '@/i18n'
import { pageSchema_build } from '@/utils/pageSchema'
import { menuTipPreview_on, menuTipPreview_page, menuTipPreview_widget } from '@/utils/menuTipPreview'
import { widgetPreviews_load, widgetPreviews_picOfRow, widgetPreviews_on, wpRowWidget, wpState } from '@/utils/widgetPreviews'

export const PAGES_PANEL_VIEWS = ['pages', 'widgets', 'previews']

export const pagesPanelViewsMixin = {
    data: () => ({ viewId: '', ratio: 0 }),
    created() { this.viewId = this._viewLoad() },
    computed: {
        viewsOn() { void this.store._settingsEpoch; return this.store.setting('fe.ux.pagesPanelViews', true) !== false },
        views() {
            if (!this.viewsOn) return null
            return [
                { id: 'pages', icon: 'pi pi-list', label: t('Pages') },
                { id: 'widgets', icon: 'pi pi-sitemap', label: t('Pages and widgets') },
                { id: 'previews', icon: 'pi pi-th-large', label: t('Page previews') },
            ]
        },
        viewCur() { if (this.onlyPage) return 'pages'; return this.viewsOn ? (PAGES_PANEL_VIEWS.includes(this.viewId) ? this.viewId : 'pages') : 'widgets' },
    },
    methods: {
        // память выбора вида: этот браузер, пользователь и база
        _viewKey() { const s = this.store, u = s.user?.id || s.user?.email || 'user', db = s.user?.database?.dbid || ''; return `pagesPanelView:${u}:${db}` },
        // хранилище недоступно (приватный режим) или выбора нет, а в этом экземпляре он уже сделан — остаётся выбор экземпляра; иначе умолчание Pages
        _viewLoad() { try { const v = localStorage.getItem(this._viewKey()); return PAGES_PANEL_VIEWS.includes(v) ? v : (this.viewId || 'pages') } catch (e) { return this.viewId || 'pages' } },
        viewSet(id) {
            if (!PAGES_PANEL_VIEWS.includes(id)) return
            this.viewId = id
            try { localStorage.setItem(this._viewKey(), id) } catch (e) { /* хранилище недоступно — выбор живёт до перезагрузки */ }
            if (id === 'previews') this.previewsLoad()
        },
        // открытие панели (вкладки): вид — из памяти (другой экземпляр мог его сменить), пропорция схемы — рабочая область текущей страницы, кэш схем — заново
        pagesViews_open() {
            this.viewId = this._viewLoad()
            this._schemas = new Map()
            if (this.viewCur === 'previews' || menuTipPreview_on(this.store)) this.previewsLoad()   // миниатюры нужны и Alt-подсказке пунктов списка / дерева
            let ratio = 0
            try {
                const el = [...document.querySelectorAll('.page-container')].find(e => e.offsetParent && e.getBoundingClientRect().width > 0)
                const r = el && el.getBoundingClientRect()
                if (r && r.width > 100 && r.height > 100) ratio = r.width / r.height
            } catch (e) { /* без DOM */ }
            if (!ratio) ratio = (window.innerWidth - 60) / Math.max(200, window.innerHeight - 100)
            this.ratio = Math.max(1.3, Math.min(2.6, Math.round(ratio * 100) / 100))
        },
        // схема страницы (карточка вида Previews): раскладка строк страницы + действующий набор открытия; кэш на время открытой панели (пометка ⧉ — _favEpoch)
        schemaOf(raw) {
            const WS = this.store.activeWORKSPACE
            const id = raw && raw._page
            if (!WS || !id) return null
            const key = id + ':' + (this.store._favEpoch || 0)
            if (!this._schemas) this._schemas = new Map()
            if (this._schemas.has(key)) return this._schemas.get(key)
            const P = WS.PAGES && WS.PAGES[id]
            let s = null
            try { s = pageSchema_build((P && P.attrs) || [], { openIds: this.store.page_openSet(WS.workspace, id).ids }) } catch (e) { s = null }
            this._schemas.set(key, s)
            return s
        },
        // миниатюры всех страниц стола (вид Page previews); картинки приходят позже схемы — карточки перерисовываются по wpState.epoch
        previewsLoad() {
            const WS = this.store.activeWORKSPACE
            if (!WS || !widgetPreviews_on(this.store)) return
            const pages = Object.values(WS.PAGES || {}).filter(P => P && P.use !== false && P.node?.value).map(P => String(P.node.value))
            widgetPreviews_load(this.store, pages, 'thumb')
        },
        // картинки виджетов страницы карточки: id виджета строки → картинка (у тиража — самый свежий экземпляр)
        picsOf(raw) {
            void wpState.epoch
            const WS = this.store.activeWORKSPACE
            const id = raw && raw._page
            if (!WS || !id || !widgetPreviews_on(this.store)) return null
            const P = WS.PAGES && WS.PAGES[id]
            if (!P) return null
            const out = {}
            const walk = (rows) => { for (const r of rows || []) { if (!r || r.use === false) continue; const wid = wpRowWidget(r); if (wid && !out[wid]) { const p = widgetPreviews_picOfRow(id, r, 'thumb'); if (p) out[wid] = p } if (r.attrs) walk(r.attrs) } }
            walk(P.attrs)
            return out
        },
        // превью пункта в Alt-подсказке — страница: схема раскладки с картинками её виджетов (как плитка вида Page previews); виджет под страницей: его картинка; нет картинки — ''
        tipPreviewOf(raw, g) {
            const WS = this.store.activeWORKSPACE
            if (!WS || !raw || !raw._page || !widgetPreviews_on(this.store)) return ''
            if (raw._widget) return menuTipPreview_widget(this.store, raw._page, raw._row, g && g.w, g && g.h)
            return menuTipPreview_page(this.schemaOf(raw), this.picsOf(raw), g && g.w, g && g.h)
        },
    },
}
